import { render, staticRenderFns } from "./DiscountBanner.vue?vue&type=template&id=6d1ccd68&scoped=true&"
import script from "./DiscountBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DiscountBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DiscountBanner.vue?vue&type=style&index=0&id=6d1ccd68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1ccd68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d1ccd68')) {
      api.createRecord('6d1ccd68', component.options)
    } else {
      api.reload('6d1ccd68', component.options)
    }
    module.hot.accept("./DiscountBanner.vue?vue&type=template&id=6d1ccd68&scoped=true&", function () {
      api.rerender('6d1ccd68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/Analyses/pages/AnalysesListPage/components/DiscountBanner/DiscountBanner.vue"
export default component.exports